const NETWORK_ERROR_PATTERNS: RegExp[] = [
  /^load failed$/i,
  /^failed to fetch$/i,
  /^networkerror/i,
  /^the internet connection appears to be offline/i,
  /^the network connection was lost/i,
  /^a server with the specified hostname could not be found/i,
  /^the request timed out/i,
  /^network request failed$/i,
];

const OUT_OF_CREDITS_ERROR_PATTERNS: RegExp[] = [
  /out of quota/i,
  /run out of quota/i,
  /out of credits?/i,
  /buy more credits/i,
  /start membership/i,
  /insufficient (?:credits?|quota)/i,
];

export function normalizePersistentChatErrorMessage(raw: unknown): string {
  let message: string;
  if (typeof raw === "string" && raw.trim()) {
    message = raw.trim();
  } else if (
    raw
    && typeof raw === "object"
    && typeof (raw as { message?: unknown }).message === "string"
    && (raw as { message: string }).message.trim()
  ) {
    message = (raw as { message: string }).message.trim();
  } else {
    message = "Something went wrong. Please try again.";
  }
  if (message === "[object Object]") {
    message = "Something went wrong. Please try again.";
  }
  if (OUT_OF_CREDITS_ERROR_PATTERNS.some((pattern) => pattern.test(message))) {
    return "You're out of credits. Please add more credits or start a membership, then try again.";
  }
  if (NETWORK_ERROR_PATTERNS.some((pattern) => pattern.test(message))) {
    return "The connection was lost. Your previous progress has been saved — please refresh to see it, or try again.";
  }
  return message;
}
